export class ViewModelProvider {
  static install (Vue) {
    const viewModel = {};

    if (window.viewModel) {
      Object.assign(viewModel, window.viewModel);
    }

    Vue.prototype.$getViewModel = () => viewModel;
    Vue.prototype.$getNamedModel = (key) => viewModel[key] || {};
  }
}
